export default "__VITE_ASSET__Cwb7SZoH__"